import { Component, Inject, OnInit } from '@angular/core';
import { Admin } from '../../../../model/admin';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'aw-create-admin',
  templateUrl: './create-admin-dialog.component.html',
  styleUrls: ['./create-admin-dialog.component.scss']
})
export class CreateAdminDialogComponent implements OnInit {


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Admin,
    public dialogRef: MatDialogRef<CreateAdminDialogComponent>,
  ) {


  }

  ngOnInit(): void {
  }


}


